import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const saveNewExamType = async (
  examTypeName: string,
  setLoading: (isLoading: boolean) => void,
  onHide: () => any,
) => {
  try {
    if (!examTypeName && examTypeName.length === 0) {
      toast.warn(`יש להזין את סוג המטלה`);
      console.warn(`Assignment type name must not be empty`);
      return;
    }
    if (examTypeName && examTypeName.length < 3) {
      toast.warn('על סוג המבחן להיות באורך של למעלה משלושה תווים');
    }
    const existingExamTypes = globalSettingsStores.examTypes.find(
      (item) => item.examTypeName === examTypeName,
    );
    if (existingExamTypes) {
      toast.warn('שם סוג מבחן כבר קיים במערכת');
      return;
    }

    setLoading(true);
    const res = await appApi.addExamType(examTypeName);
    if (res.data.ok && res.data.body) {
      globalSettingsStores.examTypes.push(res.data.body);
      toast.success(`הוספת ${examTypeName} התבצעה בהצלחה`);
      onHide();
    } else {
      toast.error(
        `יצירת סוג המטלה ${examTypeName} נכשלה, נסה שוב בעוד מספר רגעים...`,
      );
    }
    setLoading(false);

    return;
  } catch (e) {
    toast.error('הוספת סוג מטלה נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `saveNewAssignmentTypeOperation is failed with the assignment type: ${examTypeName} and the error: ${e}`,
    );
  }
};
